import { getRpcProvider } from "../../services/rpcProvider";
import { ALERT_DEFINITIONS } from "./alertDefinitions";

export async function pendingTxAlert(address, chain = "ethereum") {
  const provider = getRpcProvider(chain);

  const latestNonce = await provider.getTransactionCount(address, "latest");
  const pendingNonce = await provider.getTransactionCount(address, "pending");

  if (pendingNonce > latestNonce) {
    return {
      ...ALERT_DEFINITIONS.STUCK_TRANSACTION,
      detected: true,
    };
  }

  return {
    ...ALERT_DEFINITIONS.STUCK_TRANSACTION,
    detected: false,
  };
}
